<template lang="pug">
v-dialog(v-model="dialog", scrollable, max-width="1200")
    template(v-slot:activator="{ on, attrs }")
        v-list-item(v-bind="attrs", v-on="on" @click="closeMenu" )
            v-list-item-icon.mr-2
                v-icon(small) fa fa-layer-group
            v-list-item-title {{$t('create.overlays.addBtn')}}
                v-chip.ma-2(outlined x-small dense color="primary") Beta
                  


        //- v-btn(v-else icon, color="primaray", v-bind="attrs", v-on="on")
        //-   v-icon library_add
    v-card.dialogCard
        v-card-text.pa-6(style="max-height: 80vh")
            v-row 
                v-col(cols="12" md="4" style="overflow-y: auto; max-height: 70vh")
                    v-card.rounded-lg.list-card(flat)
                        v-tooltip(top color="primary" v-if="selectedTheme.addOverlay")
                          template(v-slot:activator="{ on, attrs }")
                            v-alert(type="warning" v-bind="attrs" v-on="on" dense)
                              | {{$i18n.t("create.hints.noOverlaysAllowedTitle")}}
                          span {{$i18n.t("create.hints.noOverlaysAllowed")}}

                        v-list.pt-0.rounded-lg(v-if="!selectedLayerItem" color="transparent")
                          v-subheader(v-if="selectedElements.length") Ausgewählt
                          OverlaySelectItem( v-for="item in selectedElements" :item="item" :selected="true" :key="item.id" @toggleItem="(item) => toggleItem(item)" )
                         
                          v-subheader Designs
                          OverlaySelectItem( v-for="item in layerItemsFiltered" :item="item" :selected="false" :key="item.id" @toggleItem="(item) => toggleItem(item)")

                          //- v-subheader Texteinblendungen
                          //- OverlaySelectItem( v-for="item in layerItems" :item="item" :selected="false" :key="item.id" @toggleItem="(item) => toggleItem(item)")
                        div.d-flex.flex-column(v-else style="height:100%")
                          v-app-bar.mb-4.rounded-lg.flex-grow-0(flat dark dense)
                              v-btn(icon @click="closeCurrentItem")
                                v-icon chevron_left
                              v-toolbar-title {{selectedLayerItem.title[$i18n.locale]}}
                              v-spacer
                              v-btn.mr-1(icon small @click="removeItem")
                                v-icon(small) fas fa-trash
                          
                          v-card-text.flex-grow-1
                            //-OverlaySelectItem(:item="selectedLayerItem" :selected="true" @toggleItem="(item) => toggleItem(item)")
                            v-form(ref="form"  v-model="valid" lazy-validation)
                              div(v-for="input in selectedLayerItem.params" :key="input.key")
                                v-text-field.mb-2.rounded-lg(v-if="input.type == 'textfield'" :type="input.type" :rules="[v => !input.required || !!v  || `${getLabel(input)} muss angegeben werden.`]" @input="onInput" v-model="input.value" :name="input.key" :label="getLabel(input)" filled rounded )
                                v-textarea.mb-2.rounded-lg(v-if="input.type == 'textarea'" :counter="input.maxLength" :rules="[v => !input.required || !!v  || `${getLabel(input)} muss angegeben werden.`, v => (v || '' ).length <= input.maxLength || `${getLabel(input)} darf max. ${input.maxLength} Zeichen sein`]" no-resize @input="onInput" v-model="input.value" :name="input.key" :label="getLabel(input)" filled rounded)
                                v-select.mb-2.rounded-lg(v-if="input.type == 'select'" v-model="input.value" :rules="[v => !input.required || !!v  || `${getLabel(input)} muss angegeben werden.`]" :items="input.options" :label="getLabel(input)" filled rounded @input="onInput" )
                          v-spacer
                v-col(cols="12" md="8")
                    PreviewCanvas(:clip="clip" :layerItems="selectedElements")

        v-card-actions.py-4.mt-4 
          v-spacer 
          v-btn.mr-4.px-8(depressed @click="cancel") {{$t('general.cancel')}}
          v-btn.px-8(depressed color="accent" :disabled="!valid" @click="submit") {{$t('general.done')}}
</template>

<script>
import Vue from "vue";
import PreviewCanvas from "./PreviewCanvas";
import { cloneDeep } from "lodash";
import OverlaySelectItem from "./OverlaySelectItem";
import { mapState } from "vuex";

import OverlayPlayer from "@/components/player/OverlayPlayer";
import { layerItems } from "@/assets/overlays/layerItems.js";
export default {
  components: {
    PreviewCanvas,
    OverlaySelectItem,
    OverlayPlayer,
  },
  props: ["clip"],
  mounted() {
    this.setLayerDataFromClip();
  },
  data() {
    return {
      dialog: false,
      selectedLayerItem: undefined,
      selectedElements: [],
      layerItems: layerItems,
      valid: false,
    };
  },
  computed: {
    ...mapState({
      selectedTheme: (state) => state.create.selectedTheme,
    }),
    layerItemsFiltered() {
      return (
        this.layerItems
          ?.map((item) => {
            const localItem = cloneDeep(item);
            // check if logos exist if needed by overlay
            // only show overlay with logos if there are logos
            const logoParam = localItem.params.find(
              (param) => param.key == "LOGOTYPE"
            );

            if (logoParam) {
              const availableOptions = [];

              if (this.selectedTheme.logoLightUrl) {
                availableOptions.push("LIGHT");
              }
              if (this.selectedTheme.logoDarkUrl) {
                availableOptions.push("DARK");
              }

              if (availableOptions.length === 0) {
                return undefined;
              }

              logoParam.defaultValue = availableOptions[0];
              logoParam.options = logoParam.options.filter((option) =>
                availableOptions.includes(option)
              );
            }
            return localItem;
          })
          .filter(
            (item) =>
              !!item &&
              !this.selectedElements.find(
                (selectedItem) => selectedItem.id === item.id
              )
          ) ?? []
      );
    },
  },
  methods: {
    cancel() {
      this.setLayerDataFromClip();
      this.closeDialog();
    },
    setLayerDataFromClip() {
      this.layerItems.map((layerItem) => {
        const overlay = this.clip.overlays?.find(
          (overlay) => overlay.id === layerItem.id
        );

        if (overlay?.params) {
          layerItem.params = overlay.params;
          if (
            !this.selectedElements.find(
              (element) => element.id === layerItem.id
            )
          ) {
            this.selectedElements.push(layerItem);
          }
        } else {
          this.selectedLayerItem = undefined;
          layerItem.params.map((param) => {
            if (!param.key.startsWith("BRANDING_") && param.value) {
              delete param.value;
            }
          });
        }
      });
    },

    submit() {
      if (
        this.selectedElements &&
        (!this.selectedLayerItem ||
          (this.selectedLayerItem && this.$refs.form?.validate()))
      ) {
        const items = cloneDeep(this.selectedElements);
        this.$emit("submit", items);
        this.closeDialog();
      } else {
        this.$emit("submit", undefined);

        this.closeDialog();
      }
    },
    closeDialog() {
      this.selectedLayerItem = undefined;
      this.valid = false;
      this.dialog = false;
    },
    closeMenu() {
      this.$emit("clicked");
      this.dialog = true;
    },
    toggleItem(item) {
      item.params.forEach((param) => {
        if (param.defaultValue && !param.value) {
          param.value = param.defaultValue;
        }
      });

      if (!this.selectedLayerItem) {
        if (!this.selectedElements.find((element) => element.id === item.id)) {
          this.selectedElements.push(item);
        }
        this.selectedLayerItem = item;
      } else if (this.selectedLayerItem.id === item.id) {
        this.selectedLayerItem = undefined;
      }
    },
    closeCurrentItem() {
      if (this.$refs.form.validate()) {
        this.selectedLayerItem = undefined;
      }
    },
    removeItem() {
      this.selectedElements = this.selectedElements.filter(
        (el) => el.id !== this.selectedLayerItem.id
      );
      this.selectedLayerItem = undefined;
      this.$refs.form.reset();
    },
    getLabel(input) {
      const translations = input.translation;

      if (!translations) {
        return this.$i18n.t(`general.${input.key.toLowerCase()}`);
      } else {
        const currentLocale = this.$i18n.locale;
        return translations[currentLocale];
      }
    },
    onInput() {
      const index = this.selectedElements.findIndex(
        (element) => element.id === this.selectedLayerItem.id
      );
      if (index === -1) return;
      Vue.set(this.selectedElements, index, this.selectedLayerItem);
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'
.dialogCard
    border-radius: $radius
    padding-top: 12px
.card
    border-radius: $radius
.v-text-field--rounded
    // border-radius: $radius
.list-card
  background: $light
  height: 100%
</style>
